<template>
  <v-snackbar
    :timeout="alert.timeout"
    :multi-line="alert.multiline"
    v-model="alert.active"
    :color="alert.color"
    top
    right
  >
    <span class="alert-text">{{ alert.message }}</span>

    <template v-slot:action="{ attrs }">
      <v-btn v-bind="attrs" dark icon @click="alert.active = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useMainStore } from '@/stores/mainStore'
import { computed } from 'vue'
const store = useMainStore()

const alert = computed(() => store.alert)
</script>

<style lang="scss" scoped>
.alert-text {
  color: black;
  font-weight: bold;
}
</style>
